// extracted by mini-css-extract-plugin
export default {"premiumWrapper":"HomePage_premiumWrapper__2ysNl"};